<template>
  <div class="towed-unit-fields">
    <h1>
      Towed Unit #{{ displayedNumber }}
      <span class="remove-tow btn" @click="removeTow">Remove</span>
    </h1>

    <div class="form-group">
      <label :for="'unitType_' + index">* Unit Type</label>
      <select
        :id="'unitType_' + index"
        name="unitType[]"
        class="form-control"
        :value="towedUnit.unitType"
        @input="towedUnitUpdate('unitType', $event.target.value)"
      >
        <option value=""></option>
        <option value="Cab-Over Camper">Cab-Over Camper</option>
        <option value="Outboard Motor">Outboard Motor</option>
        <option value="Trailer">Trailer</option>
        <option value="Watercraft">Watercraft</option>
        <option value="Other Unit">Other Unit</option>
      </select>
    </div>

    <div class="form-group">
      <label :for="'year_' + index">* Year</label>
      <select
        name="year[]"
        :id="'year_' + index"
        class="form-control"
        :value="towedUnit.year"
        @input="towedUnitUpdate('year', $event.target.value)"
      >
        <option
          v-for="yearOption in yearOptions"
          :key="yearOption"
          :value="yearOption"
        >
        {{ yearOption }}
        </option>
      </select>
    </div>

    <div class="form-group">
      <label :for="'make_' + index">* Make</label>
      <input
        :id="'make_' + index"
        name="make[]"
        type="text"
        class="form-control"
        :value="towedUnit.make"
        @input="towedUnitUpdate('make', $event.target.value)"
      >
    </div>

    <div class="form-group">
      <label :for="'model_' + index">* Model</label>
      <input
        :id="'model_' + index"
        name="model[]"
        type="text"
        class="form-control"
        :value="towedUnit.model"
        @input="towedUnitUpdate('model', $event.target.value)"
      >
    </div>

    <div class="form-group">
      <label :for="'unitId_' + index">* ID</label>
      <input
        :id="'unitId_' + index"
        name="unitId[]"
        type="text"
        class="form-control"
        :value="towedUnit.unitId"
        @input="towedUnitUpdate('unitId', $event.target.value)"
      >
    </div>

    <div class="form-group">
      <label :for="'length_' + index">Length (Feet)</label>
      <input
        :id="'length_' + index"
        name="length[]"
        type="text"
        class="form-control"
        :value="towedUnit.length"
        @input="towedUnitUpdate('length', $event.target.value)"
      >
    </div>

    <div class="form-group">
      <label :for="'licenseNum_' + index">License Number</label>
      <input
        :id="'licenseNum_' + index"
        name="licenseNum[]"
        type="text"
        class="form-control"
        :value="towedUnit.licenseNum"
        @input="towedUnitUpdate('licenseNum', $event.target.value)"
      >
    </div>

    <div class="form-group">
      <label :for="'state_' + index">State</label>
      <select
        name="state[]"
        :id="'state_' + index"
        class="form-control"
        :value="towedUnit.state"
        @input="towedUnitUpdate('state', $event.target.value)"
      >
        <optgroup v-for="optgroup in stateOptions" :label="optgroup.label" :key="optgroup.label">
          <option v-for="(label,value) in optgroup.options" :value="value" :key="value">
            {{ label }}
          </option>
        </optgroup>
      </select>
    </div>

    <div class="form-group">
      <label :for="'cmv_' + index">* Current Market Value (USD)</label>
      <div class="input-group">
        <span class="input-group-addon">$</span>
        <input
          :id="'cmv_' + index"
          name="cmv[]"
          type="number"
          class="form-control"
          :value="towedUnit.cmv"
          @input="towedUnitUpdate('cmv', $event.target.value)"
        >
      </div>
    </div>

  </div>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: 'TowedUnitFields',
  props: {
    index: Number,
    stateOptions: Object,
    towedUnit: Object,
  },
  created: function() {
    const currentYear = (new Date()).getFullYear()
    this.yearOptions = Array.from(Array(100).keys()).map(x => currentYear - x)
  },
  computed: {
    displayedNumber: function() { return this.index + 1 },
  },
  methods: {
    ...mapActions([
      'updateTowedUnit',
      'removeTowedUnit',
    ]),
    towedUnitUpdate: function(fieldkey, val) {
      let unitIndex = this.index
      let payload = {
        unitIndex, fieldkey, val,
      }
      this.updateTowedUnit(payload)
    },
    removeTow: function() {
      this.removeTowedUnit(this.index)
    },
  },
}
</script>

<style>
</style>
